import React, { Component } from 'react';
import Layout from '../layout/Main';
import {http, baseURL} from '../misc/http';
import htmlParse from 'string-strip-html'
import {Link} from 'react-router-dom';
import defaultImage from '../assets/default.jpg';

export default class Search extends Component {
  state = {
    listSearch: [],
    keyword: ''
  }

  handleSearch = async () => {
    let params = {
      method:'GET',
      path:'search?keyword='+this.state.keyword,
      showMessage: false
    }
    let {data} = await http(params);
    if (data.code === 200) {
      this.setState({listSearch: data.data})
    } else {
      this.setState({listSearch: []})
    }
  }

  handleKeyPress = ({keyCode}) => {
    if (keyCode === 13) this.handleSearch()
  }

  renderResult = () => {
    return(
      this.state.listSearch.length ? this.state.listSearch.map(e => {
        let content = htmlParse(e.content);
        if (content.length > 250) content = `${content.substring(0, 250)} ...`;
        return (
          <ul style={{paddingLeft: 0, paddingRight: 0, paddingBottom: 5}}>
            <Link to={e.url} target='_blank' style={{display: 'flex'}}>
              <img src={e.image ? baseURL+e.image : defaultImage} style={{maxHeight: '85px', maxWidth: '85px'}}/>
              <div style={{paddingLeft: 5}}>
                <div style={{fontSize: 16, fontWeight: 'bold'}}>
                  {e.title}
                </div>
                <p style={{marginBottom: 0, marginTop: 0}}>
                  {content}
                </p>
                <p style={{color: 'black', cursor: 'default'}}>
                  {`type : ${e.type}`}
                </p>
              </div>
            </Link>
          </ul>
        )
      }) : <div>No data founded</div>
    )
  }

  render() {
    return (
      <Layout>
        <div className="container daftar-ca" style={{padding:'50px 0px'}}>
          <div className="row mx-0">
            <div className="col-lg-10 col-sm-12">
              <input className="form-control" type="text" placeholder="Silahakan masukan kata kunci, ex. tanda tangan elektronik" style={{padding: '10px 20px',height: '37px', borderRadius: '5px'}} onKeyDown={this.handleKeyPress} onChange={({target: {value}}) => this.setState({keyword: value})}/>
            </div>
            <div className="col-lg-2 col-sm-12">
              <button className="btn btn-blue w-100" onClick={() => this. handleSearch()}>Cari</button>
            </div>
          </div>
          <div style={{paddingLeft: 15, paddingRight: 15, paddingTop: 15}}>
            {this.renderResult()}
          </div>
        </div>
      </Layout>
    )
  }
}
